import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MaterialModule } from './../../material/material.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LoginComponent } from './header/login/login.component';
import { ReceiveAdviceComponent } from './receive-advice/receive-advice.component';
import { ReceiveContactComponent } from './receive-contact/receive-contact.component';
import { FreeTrialComponent } from './free-trial/free-trial.component';
import { VideoComponent } from './video/video.component';
import { CustomersComponent } from './customers/customers.component';
import { NewsEventComponent } from './news-event/news-event.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ButtonFreeTrialComponent } from './button-free-trial/button-free-trial.component';
import { ButtonReceiveAdviceComponent } from './button-receive-advice/button-receive-advice.component';
import { ChatComponent } from './chat/chat.component';
import { RouterModule } from '@angular/router'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BannerImgComponent} from './banner-img/banner-img.component'
import { SlideProductsComponent } from './slide-products/slide-products.component';
import { CardSlideProductsComponent } from './card-slide-products/card-slide-products.component';
import { SlideHotNewsEventComponent } from '../../component/user/slide-hot-news-event/slide-hot-news-event.component';
import { CardHotNewsEventComponent } from '../../component/user/card-hot-news-event/card-hot-news-event.component';
import { SafePipe } from './safe-pipe/safe-pipe.component'
import { IonicModule } from '@ionic/angular';
import { HeaderInterfaceComponent } from './header-interface/header-interface.component';
import { WebappFieldsUserC001Component } from 'src/app/components/webapp-products-001/user/webapp-fields-user-c001/webapp-fields-user-c001.component';
import { WebappSoftwareC001UserSubmenuComponent } from 'src/app/components/webapp-software-001/user/webapp-software-c001-user-submenu/webapp-software-c001-user-submenu.component'
import { WebappSoftwareC001UserSubmenuMobileComponent } from 'src/app/components/webapp-software-001/user/webapp-software-c001-user-submenu-mobile/webapp-software-c001-user-submenu-mobile.component'
import { WebappInterfaceStoreC001UserFieldsComponent} from 'src/app/components/webapp-interface-store-001/user/webapp-interface-store-c001-user-fields/webapp-interface-store-c001-user-fields.component'


let component = [
  HeaderComponent, ChatComponent, FooterComponent, LoginComponent, ReceiveAdviceComponent,
  FreeTrialComponent, VideoComponent, CustomersComponent, NewsEventComponent,
  ForgotPasswordComponent, ButtonFreeTrialComponent, ButtonReceiveAdviceComponent,
  SafePipe,BannerImgComponent,SlideProductsComponent,CardSlideProductsComponent, WebappFieldsUserC001Component,
  SlideHotNewsEventComponent, CardHotNewsEventComponent, ReceiveContactComponent,HeaderInterfaceComponent,
  WebappSoftwareC001UserSubmenuComponent ,
  WebappInterfaceStoreC001UserFieldsComponent,
  WebappSoftwareC001UserSubmenuMobileComponent
  
]

@NgModule({
  declarations: component,
  imports: [
    CommonModule, MaterialModule, MatFormFieldModule,
    RouterModule, FormsModule, ReactiveFormsModule, IonicModule,
    
  ],
  exports: component
})
export class ComponentModule { }
